import { render, staticRenderFns } from "./GalleryModeForm.vue?vue&type=template&id=a5e155f4&scoped=true&"
import script from "./GalleryModeForm.vue?vue&type=script&lang=ts&"
export * from "./GalleryModeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e155f4",
  null
  
)

export default component.exports